/**
 * Final Jeopardy secret answer entry (M3.5, FR-6.3 — one control, one action). A
 * single text input + submit. The typed answer is secret (the server hides it
 * from other players until reveal); this component only sends it once.
 */

import { useState } from 'react';
import { FINAL_PERIL } from './brand';

export interface FinalAnswerInputProps {
  onSubmit: (text: string) => void;
}

export function FinalAnswerInput({ onSubmit }: FinalAnswerInputProps): React.JSX.Element {
  const [text, setText] = useState('');
  const valid = text.trim() !== '';

  return (
    <form
      className="final-answer"
      data-testid="final-answer"
      onSubmit={(e) => {
        e.preventDefault();
        if (valid) onSubmit(text.trim());
      }}
    >
      <label className="final-answer__label">Your response (secret)</label>
      <input
        type="text"
        aria-label={`Your ${FINAL_PERIL} response`}
        data-testid="final-answer-text"
        placeholder="What is…?"
        value={text}
        onChange={(e) => setText(e.target.value)}
        maxLength={500}
        autoFocus
      />
      <button
        type="submit"
        className="btn btn--primary"
        data-testid="final-answer-submit"
        disabled={!valid}
      >
        Lock in answer
      </button>
    </form>
  );
}
